import { saveAs } from "file-saver";
import XLSX from "xlsx-js-style";

export const downloadExcel = (gridData) => {
  const mappedData = gridData.map((item) => ({
    "Id": item.SPTRN,
    "RowId": "",
    "SPTRN": item.SPTRN,
    "DEGTRN": item.ReturnDEGTRN,
    "Transaction Date": item.DFECTransactionDate,
    "Payment Status": item.PaymentStatus,
    "Amount": item.Amount,
    "Payment Method": item.ReturnPymtMethod
  }));
  const worksheet = XLSX.utils.json_to_sheet(mappedData);
  const headerCells = Object.keys(mappedData[0]);
  headerCells.forEach((key, index) => {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index }); // r=0 → header row
    if (!worksheet[cellAddress]) return;

    worksheet[cellAddress].s = {
      font: { bold: true }
    };
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ReconciliationReport");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, "Reconciliation_Report.xlsx");
};

export const convertToXML = (data, servCode) => {
  let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
  xml += '<Reconciliation>\n';

  // Service provider details
  xml += '  <ServiceProviderDetails>\n';
  xml += '    <SPCODE>DAHC</SPCODE>\n';
  xml += `    <SERVCODE>${servCode}</SERVCODE>\n`;
  xml += '  </ServiceProviderDetails>\n';

  // Transactions
  xml += '  <TransactionDetails>\n';
  data.forEach((entry) => {
    xml += '    <Transaction>\n';
    xml += `      <SPTRN>${entry.SPTRN}</SPTRN>\n`;
    xml += `      <TransDate>${entry.DFECTransactionDate}</TransDate>\n`;
    xml += `      <Amount>${entry.Amount}</Amount>\n`;
    xml += `      <DEGTRN>${entry.ReturnDEGTRN}</DEGTRN>\n`;
    xml += `      <Status>${entry.statusCode}</Status>\n`;
    xml += `      <PaymentMethod>${entry.ReturnPymtMethod}</PaymentMethod>\n`;
    xml += '    </Transaction>\n';
  });
  xml += '  </TransactionDetails>\n';

  xml += '</Reconciliation>';
  return xml;
};


export const downloadXML = (gridData, servCode) => {
  const xmlString = convertToXML(gridData, servCode);
  const blob = new Blob([xmlString], { type: "application/xml" });
  saveAs(blob, "Reconciliation_Report.xml");
};

// export const dateFormatter =(date)=>{
//     const isoDate = new Date(date).toISOString().split('.')[0] + 'Z';
//     console.log(isoDate);
//     return isoDate;
// }

export const dateFormatter = (date, isToDate = false) => {
  const inputDate = new Date(date);
  if (isToDate) {
    inputDate.setUTCHours(23, 59, 59, 999);
  } else {
    inputDate.setUTCHours(0, 0, 0, 0);
  }

  return inputDate.toISOString().split('.')[0] + 'Z';
};